import {
  HOUSE_KEEPING_GET_ROOM_SERVICE_STATUS_EXPORT,
  HOUSE_KEEPING_GET_ROOM_SERVICE_STATUS_GET_ALL,
  HOUSE_KEEPING_GET_ROOM_SERVICE_STATUS_ROOM_DETAILS,
  HOUSE_KEEPING_REINSTATE_ROOM_SERVICE_STATUS,
  HOUSE_KEEPING_UPDATE_ROOM_SERVICE_STATUS,
} from '@constants/ApiEndpoints/HouseKeepingRootEndpoint';
import { AxiosInstance } from 'axios';
import { FilterMenuModel } from 'pages/HouseKeepingModule/pages/RoomServiceStatusPage/models/FilterMenuModel';
import {
  BulkServiceStatusUpdateResponseModel,
  PeriodFormModel,
  RoomStatusDetailsModel,
  RoomStatusFormModel,
  RoomStatusListModel,
} from 'pages/HouseKeepingModule/pages/RoomServiceStatusPage/models/RoomStatusModel';
import { sprintf } from 'sprintf-js';
import { getExportConfig, handleFileExport } from '../../../pages/ReportModule/helpers/fileExport';
import { exportFileTypes } from '../../../pages/ReportModule/models/exportFileTypes';

export type Params = {
  search?: string;
  limit?: number;
  offset?: number;
};

export const getAll =
  (axios: AxiosInstance) =>
  async (
    params?: {
      room_number?: string | null | undefined;
      limit?: number;
      offset?: number;
      from: string;
      to: string;
    } & Partial<FilterMenuModel>
  ): Promise<RoomStatusListModel> =>
    await axios
      .get(HOUSE_KEEPING_GET_ROOM_SERVICE_STATUS_GET_ALL, { params })
      .then(({ data }) => data);

export const exportPDF =
  (axios: AxiosInstance) =>
  async (
    params?: {
      room_number?: string | null | undefined;
      limit?: number;
      offset?: number;
      from: string;
      to: string;
    } & Partial<FilterMenuModel> & {
        file_type: exportFileTypes;
        autoPrint?: boolean;
        send?: boolean;
      }
  ): Promise<void> => {
    const { autoPrint, send, ...requestParams } = params || {};

    return await axios
      .get(`${HOUSE_KEEPING_GET_ROOM_SERVICE_STATUS_EXPORT}`, {
        params: { ...requestParams },
        ...getExportConfig(params),
      })
      .then(response => {
        handleFileExport(response, {
          file_type: params?.file_type,
          filename: 'room-service-status-report',
          autoPrint,
          send,
        });
      });
  };

export const update =
  (axios: AxiosInstance) =>
  async (data: Partial<RoomStatusFormModel>): Promise<BulkServiceStatusUpdateResponseModel> => {
    return await axios
      .post(HOUSE_KEEPING_GET_ROOM_SERVICE_STATUS_GET_ALL, data)
      .then(({ data }) => data);
  };

export const bulkUpdateRoomServiceStatus =
  (axios: AxiosInstance) =>
  async (payload: {
    data: PeriodFormModel[];
    room_ids: number[];
    target: number;
  }): Promise<BulkServiceStatusUpdateResponseModel> => {
    return await axios
      .put(HOUSE_KEEPING_UPDATE_ROOM_SERVICE_STATUS, {
        ...payload,
        data: payload.data,
      })
      .then(({ data }) => data);
  };

export const bulkReinstateRoomServiceStatus =
  (axios: AxiosInstance) =>
  async (payload: { roomIds: number[] }): Promise<BulkServiceStatusUpdateResponseModel> => {
    return await axios
      .patch(HOUSE_KEEPING_REINSTATE_ROOM_SERVICE_STATUS, {
        room_ids: payload.roomIds,
      })
      .then(({ data }) => data);
  };

/**
 * This function is used to get the details of a room
 * @param roomId: The id of the room to get the details of
 * @returns The details of the room
 */
export const getRoomDetails =
  (axios: AxiosInstance) =>
  async (roomId: number): Promise<RoomStatusDetailsModel> => {
    return await axios
      .get(sprintf(HOUSE_KEEPING_GET_ROOM_SERVICE_STATUS_ROOM_DETAILS, roomId), {})
      .then(({ data }) => data);
  };
